import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e82d318a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "placeholder", "maxlength"]
const _hoisted_2 = {
  key: 0,
  class: "select_styled"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]

import { computed, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputSelect',
  props: {
    modelValue: null,
    list: null,
    disabled: { type: Boolean },
    class: null,
    placeholder: null,
    maxLength: null
  },
  emits: ["update:modelValue", "change", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: unknown): void;
  (e: 'change'): void;
  (e: 'input'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, list: string[], disabled?: boolean, class?: string, placeholder?: string, maxLength?: number }




const model = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

const disabled = computed(() => props.disabled);
const list = computed(() => props.list);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["is-frame", props.class])
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      type: "text",
      class: "editText",
      disabled: _unref(disabled),
      placeholder: props.placeholder,
      maxlength: props.maxLength,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('input'))),
      onChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change')))
    }, null, 40, _hoisted_1), [
      [_vModelText, _unref(model)]
    ]),
    (!_unref(disabled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
            disabled: _unref(disabled),
            onChange: _cache[4] || (_cache[4] = ($event: any) => (emit('change')))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (str) => {
              return (_openBlock(), _createElementBlock("option", {
                key: str,
                value: str
              }, _toDisplayString(str), 9, _hoisted_4))
            }), 128))
          ], 40, _hoisted_3), [
            [_vModelSelect, _unref(model)]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})